import { colors } from '@material-ui/core';

const white = '#FFFFFF';
//https://material-ui.com/customization/color/
export default {
  primary: {
    contrastText: white,
    dark: colors.teal[900],
    main: colors.teal[500],
    light: colors.teal[100]
  },
  secondary: {
    contrastText: white,
    dark: colors.deepPurple[900],
    main: colors.deepPurple.A700,
    light: colors.deepPurple.A400
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    special: colors.lightGreen[600],
    link: colors.blue[600]
  },
  link: colors.blue[800],
  icon: colors.blueGrey[600],
  background: {
    default: '#F4F6F8',
    paper: white
  },
  divider: colors.grey[200]
};
